import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { EventTypeEnum } from '../enum/event-type.enum';

@Injectable({ providedIn: 'root'})
export class EventActionService {
    private eventSubject: Subject<EventTypeEnum> = new ReplaySubject(1);

    constructor() {}

    get getEventSubject(): Observable<EventTypeEnum> {
        return this.eventSubject.asObservable();
    }

    resetEventObserver(): void {
        this.eventSubject = new ReplaySubject(1);
    }

    sendCustomEvent(eventType : EventTypeEnum): void {
        this.eventSubject.next(eventType);
    }


}